<template>
	<div class="pronto-progress-pie" :style="cssVars" />
</template>

<script>
const MIN_PERCENT = 5

export default {
	name: 'ProgressPie',
	props: {
		size: {
			type: [String, Number],
			default: '30px',
		},
		percent: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		cssVars() {
			let { size, percent } = this
			if (percent < MIN_PERCENT) {
				percent = MIN_PERCENT
			}
			return {
				'--size': isNaN(size) ? size : `${size}px`,
				'--percentage': `${percent}%`,
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.pronto-progress-pie {
	--color: #9c9ea4;
	flex-shrink: 0;
	border: calc(var(--size) / 10) solid var(--color);
	background: conic-gradient(var(--color) var(--percentage), white 0);
	border-radius: 50%;
	width: var(--size);
	height: var(--size);
}
</style>
